
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v26H5V3zm2 2v22h16V5H7zm10 7h4v2h-2v4.5c0 1.383-1.117 2.5-2.5 2.5-.386 0-.604-.283-.906-.469-.408.824-1.11 1.469-2.094 1.469a2.497 2.497 0 01-2.5-2.5V15H9v-2h4v6.5c0 .217.283.5.5.5s.5-.283.5-.5V15h2v2s.007.652.156 1.25c.075.299.198.577.281.688s.021.063.063.063c.217 0 .5-.283.5-.5v-6.5z"}})])
          )
        }
      }
    